import { useState } from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const honeypot = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypot && honeypot.value.trim() !== "") {
      setSubmitted(true);
      return;
    }
    if (!email.trim()) return;
    setSubmitting(true);
    try {
      const formData = new URLSearchParams();
      formData.append("email", email);
      await fetch("https://readdy.ai/api/form/d8t4m1r9b1tpbugifmg0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="bg-foreground-950 rounded-3xl mx-4 md:mx-8 lg:mx-16 mb-6 md:mb-8 overflow-hidden">
      <div className="px-6 md:px-10 lg:px-14 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[2fr_1fr_1fr_1.5fr] gap-10 md:gap-8">
          <div>
            <h3 className="font-heading text-2xl md:text-3xl font-semibold text-background-50 mb-4">
              Hipobuy Spreadsheet
            </h3>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-md mb-6">
              L'outil de suivi e-commerce nouvelle génération. Automatisez, analysez et développez votre business en ligne avec un spreadsheet intelligent.
            </p>
            {submitted ? (
              <p className="text-primary-300 text-sm font-medium">Merci pour votre inscription !</p>
            ) : (
              <form onSubmit={handleSubmit} data-readdy-form className="flex flex-col sm:flex-row gap-3 max-w-md">
                <div className="hp-field">
                  <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" />
                </div>
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Votre adresse email"
                  required
                  className="flex-1 bg-transparent border-b border-foreground-600 text-background-50 text-sm py-2 px-1 outline-none focus:border-primary-400 transition-colors placeholder:text-foreground-500"
                />
                <button
                  type="submit"
                  disabled={submitting}
                  className="px-6 py-2.5 bg-background-50 text-foreground-950 rounded-full text-sm font-medium whitespace-nowrap hover:bg-background-100 transition-colors cursor-pointer disabled:opacity-50"
                >
                  {submitting ? "..." : "S'abonner"}
                  {!submitting && <i className="ri-arrow-right-line ml-1.5 text-xs"></i>}
                </button>
              </form>
            )}
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-5">Navigation</h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline underline-offset-4 whitespace-nowrap">Accueil</Link>
              <Link to="/guide-hipobuy-spreadsheet" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline underline-offset-4 whitespace-nowrap">Guide Complet</Link>
              <Link to="/quest-ce-que-hipobuy-spreadsheet" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline underline-offset-4 whitespace-nowrap">Qu'est-ce que Hipobuy</Link>
              <Link to="/comment-ca-fonctionne-hipobuy-spreadsheet" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline underline-offset-4 whitespace-nowrap">Comment ça fonctionne</Link>
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline underline-offset-4 whitespace-nowrap">Kaspreadsheet</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-5">Ressources SEO</h4>
            <div className="flex flex-col gap-3">
              <Link to="/fonctionnalites-hipobuy-spreadsheet" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline underline-offset-4 whitespace-nowrap">Fonctionnalités</Link>
              <Link to="/tarifs-hipobuy-spreadsheet" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline underline-offset-4 whitespace-nowrap">Tarifs</Link>
              <Link to="/securite-confidentialite-hipobuy-spreadsheet" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline underline-offset-4 whitespace-nowrap">Sécurité</Link>
              <Link to="/analyse-concurrents-hipobuy-spreadsheet" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline underline-offset-4 whitespace-nowrap">Analyse concurrents</Link>
              <Link to="/hipobuy-spreadsheet-vs-excel" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline underline-offset-4 whitespace-nowrap">vs Excel</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-5">Contact</h4>
            <div className="flex flex-col gap-2 mb-6">
              <a href="mailto:contact@hipobuyspreadsheet.biz" className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">
                contact@hipobuyspreadsheet.biz
              </a>
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap">
                kaspreadsheet.com
              </a>
            </div>
            <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider mb-3">Adresse</h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              123 Avenue des Champs-Élysées<br />
              75008 Paris, France
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800 px-6 md:px-10 lg:px-14 py-5">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-background-50 transition-colors underline underline-offset-4 whitespace-nowrap">
              <i className="ri-twitter-x-line mr-1.5"></i>Twitter
            </a>
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-background-50 transition-colors underline underline-offset-4 whitespace-nowrap">
              <i className="ri-linkedin-line mr-1.5"></i>LinkedIn
            </a>
          </div>
          <p className="text-xs text-foreground-500 whitespace-nowrap">
            &copy; 2025 Hipobuy Spreadsheet. Tous droits réservés.
          </p>
          <div className="flex items-center gap-5">
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-400 hover:text-background-50 transition-colors underline underline-offset-4 whitespace-nowrap">
              Confidentialité
            </a>
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-400 hover:text-background-50 transition-colors underline underline-offset-4 whitespace-nowrap">
              Conditions
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}